var React = require('react');

function ArrowLeftWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.81081 15H3.6615L0 7.50166L3.6615 9.53674e-07H6.81081L3.14931 7.50166L6.81081 15Z","fill":"white"}));
}

ArrowLeftWhite.defaultProps = {"width":"7","height":"15","viewBox":"0 0 7 15","fill":"none"};

module.exports = ArrowLeftWhite;

ArrowLeftWhite.default = ArrowLeftWhite;
